const Parser = {
  phone: (value) => {
    // Remove todos os caracteres não numéricos, exceto o prefixo +55
    const phoneNumber = value.replace(/[^\d]/g, "").slice(2);

    // Adiciona o código de país +55 e formata conforme a máscara desejada
    const match = phoneNumber.match(/^(\d{2})(\d{1})(\d{4})(\d{4})$/);

    if (match) {
      return `+55 (${match[1]}) ${match[2]} ${match[3]}-${match[4]}`;
    } else if (phoneNumber.length <= 2) {
      return `+55 (${phoneNumber}`;
    } else if (phoneNumber.length <= 3) {
      return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2)}`;
    } else if (phoneNumber.length <= 7) {
      return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(
        2,
        3
      )} ${phoneNumber.slice(3)}`;
    } else {
      return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(
        2,
        3
      )} ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)}`;
    }
  },

  date: {
    ddmmyyyy: (value) => {
      return value.split("-").reverse().join("/");
    },
  },

  price: {
    brl: (cents) => {
      if (!cents) return cents;
      const numericValue = `${cents}`?.replace(/\D/g, "");
      const integerPart = numericValue.slice(0, -2)?.replace(/^0+/, "") || "0";
      const decimalPart = numericValue.slice(-2);

      const formattedInteger = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        "."
      );

      return `${formattedInteger},${decimalPart}`;
    },
  },

  interval: {
    adjective: (interval) => {
      return {
        week: "Semanal",
        month: "Mensal",
        bimonthly: "Bimestral",
        quarterly: "Trimestral",
        semiannual: "Semestral",
        year: "Anual",
      }[interval];
    },
    noun: (interval) => {
      return {
        week: "Semana",
        month: "Mês",
        bimonthly: "Bimestre",
        quarterly: "Trimestre",
        semiannual: "Semestral",
        year: "Ano",
      }[interval];
    },
  },
};

export default Parser;
